export const environment = {
  production: true,
  timezone: 'GMT',
  validQualifiers: ['MPAA', 'TVPG'],
  langFilters: ['es','en'],
  defaultLang: 'es',
  apiUrl: 'https://86xcffn8cf.execute-api.us-west-2.amazonaws.com/api',
};